import React, { FunctionComponent } from 'react'
import { Main } from '@vwfs-bronson/bronson-react'
import Header from './Header'
import Footer from './Footer'
import { Page } from '../../models/page'
import { SkipLink } from '../SkipLink/SkipLink'

export type DefaultLayoutProps = {
  pages: Page[]
}

const DefaultLayout: FunctionComponent<DefaultLayoutProps> = ({
  pages,
  children,
}) => {
  return (
    <>
      <SkipLink id="main" />
      <Header />
      <Main id="main">{children}</Main>
      <Footer pages={pages} />
    </>
  )
}

export { DefaultLayout }
